<div class="global-search-input-group">
  <input 
    type="text"
    class="form-control"
    placeholder="{{ 'placeholders.search' | translate }}"
    id="globalSearch"
    [(ngModel)]="globalSearch"
    (ngModelChange)="globalSearchUpdate($event)"
    (focus)="isDataModalVisible = searchData && (searchData.cases.length > 0 || searchData.problemRecords.length > 0 || searchData.knowledgeLibrary.length > 0)"
    autocomplete="off"
  >
  <div class="input-group-append" [ngClass]="{'search-disabled': searching}">
    @if(searching) {
      <i class="spinner-border" role="status"></i>
    } @else {
      <i class="bi bi-search"></i>
    }
  </div>
</div>

<div *ngIf="isDataModalVisible && searchData" class="global-search-popup">
  <div class="global-search-popup-title">
    <i (click)="closePopup()" class="bi bi-x-lg close-button"></i>
  </div>
  <div class="global-search-popup__content">
    @if(searchData && (searchData.cases.length > 0 || searchData.problemRecords.length > 0 || searchData.knowledgeLibrary.length > 0)) 
      {
      <div class="item mb-3" *ngFor="let item of searchData | keyvalue">
        <div class="center-line" *ngIf="item && item.value.length > 0">
          <span class="center-line-text">{{ ('title.global_search.' + item.key) | translate }}</span>
          <span class="center-line-end"></span>
          <span class="center-line-text center-line-link" (click)="showAllResults(item.key)">{{ 'label.show_all_results' | translate }}</span>
        </div>
        <div class="subitem-wrapper" *ngFor="let subitem of item.value" (click)="goToItem(item.key, subitem)">
          <div class="subitem-item">{{ subitem.identifier }}</div>
          <div class="subitem-item second">{{ subitem.title }}</div>
        </div>
      </div>
    } @else {
      <div class="global-search-popup-no-data">{{ 'label.no_results' | translate }}</div>
    }
    
  </div>
</div>
